import React from "react";
import "../components/Styles/Achievement.css";

function Achievement() {
  return (
    <>
      <div className="team-header">
        <h1 className="team-title">Our Achievements</h1>
      </div>
      <div className="club-achievements">
        <div className="container">
          <div className="row text-center align-items-center">
            <div className="col-lg-12 col-md-6">
              <div className="achievement-item">
                <div className="achievement-content">
                  <table className="achievement-table" border="1">
                    <tbody>
                      <tr>
                        <th colSpan="6" className="year-header">
                          2026
                        </th>
                      </tr>
                      <tr>
                        <th>S.No</th>
                        <th>Club Member</th>
                        <th>Event Name</th>
                        <th>Title of Project/Product</th>
                        <th>Achievement</th>
                        <th>Year</th>
                      </tr>
                      <tr>
                        <td>1</td>
                        <td>Virajith, Tanishka
                        </td>
                        <td>HAVANA'26 GITAM</td>
                        <td>Paper and poster presentation</td>
                        <td>Runner Ups</td>
                        <td>2026</td>
                      </tr>
                      <tr>
                        <td>2</td>
                        <td>
                          Prasheetha
                        </td>
                        <td>
                          IIT BOMBAY TECH FEST, GITAM</td>
                        <td>Code Code Competition</td>
                        <td>1st place</td>
                        <td>2026</td>
                      </tr>
                      <tr>
                        <td>3</td>
                        <td>
                          Charan
                        </td>
                        <td>
                          IIT BOMBAY TECH FEST, GITAM</td>
                        <td>Code Code Competition</td>
                        <td>2nd place</td>
                        <td>2026</td>
                      </tr>
                      <tr>
                        <td>4</td>
                        <td>
                          Ranjith
                        </td>
                        <td>
                          IIT BOMBAY TECH FEST, GITAM</td>
                        <td>Code Code Competition</td>
                        <td>3rd place</td>
                        <td>2026</td>
                      </tr>
                      <tr>
                        <td>5</td>
                        <td>
                          Gopal Raju
                        </td>
                        <td>
                          IIT BOMBAY TECH FEST, GITAM</td>
                        <td>Code Code Competition</td>
                        <td>5th place</td>
                        <td>2026</td>
                      </tr>


                    </tbody>
                  </table>
                  <table className="achievement-table" border="1">
                    <tbody>
                      <tr>
                        <th colSpan="6" className="year-header">
                          2025
                        </th>
                      </tr>
                      <tr>
                        <th>S.No</th>
                        <th>Club Member</th>
                        <th>Event Name</th>
                        <th>Title of Project/Product</th>
                        <th>Achievement</th>
                        <th>Year</th>
                      </tr>
                      <tr>
                        <td>1</td>
                        <td>
                          M.Pradyot Reddy, M.Supraja, I.Sriram, M.Sai Avyay, Y.Anushka, CH.Virajith Krishi Mithra
                        </td>
                        <td>NCNTAIA-25,SNIST</td>
                        <td>Paper and poster presentation</td>
                        <td>Best Poster Presentation Award</td>
                        <td>2025</td>
                      </tr>
                      <tr>
                        <td>2</td>
                        <td>
                          G.Surya Teja, S.Sri Charan, K.Rajesh Varma, P.Vaibhav, B.Bhavateja, V.Harshitha
                        </td>
                        <td>NCNTAIA-25,SNIST</td>
                        <td>Paper and poster presentation</td>
                        <td>Best Poster Presentation Award</td>
                        <td>2025</td>
                      </tr>


                    </tbody>
                  </table>
                  <table className="achievement-table" border="1">
                    <tbody>
                      <tr>
                        <th colSpan="6" className="year-header">
                          2024
                        </th>
                      </tr>
                      <tr>
                        <th>S.No</th>
                        <th>Club Member</th>
                        <th>Event Name</th>
                        <th>Title of Project/Product</th>
                        <th>Achievement</th>
                        <th>Year</th>
                      </tr>
                      <tr>
                        <td>1</td>
                        <td>
                          Anirudh,Surya Prakash
                        </td>
                        <td>Havana,GITAM University </td>
                        <td>Paper and poster presentation</td>
                        <td>1st prize </td>
                        <td>2024</td>
                      </tr>
                      <tr>
                        <td>2</td>
                        <td>Dheeraj</td>
                        <td>Adastra, SNIST </td>
                        <td>Paper and poster presentation</td>
                        <td>1st prize</td>
                        <td>2024</td>
                      </tr>
                      <tr>
                        <td>2</td>
                        <td>Dheeraj</td>
                        <td>Bhaswara, Geetanjali College</td>
                        <td>Paper and poster presentation</td>
                        <td>1st prize</td>
                        <td>2024</td>
                      </tr>
                      <tr>
                        <td>3</td>
                        <td>
                          B.Joshitha, Mohan Sai Gutti, Avikshith Arcot,M.Eesha (TEAM
                          TECHNOBOTS)
                        </td>
                        <td>Convergence 2k25, VNR VJIET</td>
                        <td>Paper and poster presentation</td>
                        <td>1st prize</td>
                        <td>2024</td>
                      </tr>

                    </tbody>
                  </table>
                  <table className="achievement-table" border="1">
                    <tbody>
                      <tr>
                        <th colSpan="6" className="year-header">
                          2023
                        </th>
                      </tr>
                      <tr>
                        <th>S.No</th>
                        <th>Club Member</th>
                        <th>Event Name</th>
                        <th>Title of Project/Product</th>
                        <th>Achievement</th>
                        <th>Year</th>
                      </tr>

                      <tr>
                        <td>1</td>
                        <td>Shravani, Saketh, Saravanan, Sathwika</td>
                        <td>CONVERGENCE 2K23, VNR VJIET</td>
                        <td>Robo Soccer</td>
                        <td>1st prize</td>
                        <td>2023</td>
                      </tr>

                      <tr>
                        <td>2</td>
                        <td>Shravani, Saketh, Saravanan, Sathwika</td>
                        <td>CONVERGENCE 2K23, VNR VJIET</td>
                        <td>Robo Rally</td>
                        <td>Runner up</td>
                        <td>2023</td>
                      </tr>
                      <tr>
                        <td>3</td>
                        <td>Tarun Aditya , Shivani kreethigari </td>
                        <td>SUDHEE 2023,CBIT</td>
                        <td> Technical Paper presentation </td>
                        <td>Best Paper Exhibitor Award</td>
                        <td>2023</td>
                      </tr>
                      <tr>
                        <td>4</td>
                        <td>Shivani kreethigari, Chavva Sai Harshika</td>
                        <td>DAKSHA’23, ANURAG </td>
                        <td> Paper Presentation from CSE department </td>
                        <td>1st place</td>
                        <td>2023</td>
                      </tr>
                      <tr>
                        <td>5</td>
                        <td>Shivani kreethigari, Chavva Sai Harshika</td>
                        <td>DAKSHA’23, ANURAG </td>
                        <td> Paper Presentation from ECE department</td>
                        <td>1st place</td>
                        <td>2023</td>
                      </tr>
                      <tr>
                        <td>6</td>
                        <td>Pandraveti Bhavana, Sayapuri Vedhashree</td>
                        <td>DAKSHA’23, ANURAG </td>
                        <td> paper Presentation from IT department </td>
                        <td>1st place</td>
                        <td>2023</td>
                      </tr>
                      <tr>
                        <td>7</td>
                        <td>Mugala Shravani, Murugan Sarvanana </td>
                        <td>DAKSHA’23, ANURAG </td>
                        <td> Paper Presentation from ECE department </td>
                        <td>2nd place</td>
                        <td>2023</td>
                      </tr>
                      <tr>
                        <td>8</td>
                        <td>
                          Mugala Shravani, Saathvika Revalla, Lahareesh, D.
                          Deekshith{" "}
                        </td>
                        <td>VALOROUS 23, MLRITM</td>
                        <td>Line Follower</td>
                        <td>1st place</td>
                        <td>2023</td>
                      </tr>
                      <tr>
                        <td>9</td>
                        <td>
                          Bangaru Rakesh, Murugan Sarvanana, Venkata Sai Kiran
                          Narra , Karthik Shyam
                        </td>
                        <td>VALOROUS 23, MLRITM</td>
                        <td> Bluetooth RC car Race</td>
                        <td>1st place</td>
                        <td>2023</td>
                      </tr>
                      <tr>
                        <td>10</td>
                        <td>
                          P. Tapaswini, N. Rishwanth Reddy, Narayana Saketh
                          Amarti{" "}
                        </td>
                        <td>VALOROUS 23, MLRITM</td>
                        <td>All Terrain</td>
                        <td>2nd prize </td>
                        <td>2023</td>
                      </tr>
                      <tr>
                        <td>11</td>
                        <td>
                          N. Abhinav, L. Yashwanth, Samala Tarun Aditya, Bhargav{" "}
                        </td>
                        <td>VALOROUS 23, MLRITM</td>
                        <td>Maze Runner </td>
                        <td>2nd prize </td>
                        <td>2023</td>
                      </tr>
                      <tr>
                        <td>12</td>
                        <td>
                          Shivani kreethigari, chavva Sai Harshika, Maliha{" "}
                        </td>
                        <td>DAKSHA’23, ANURAG </td>
                        <td> Paper Presentation</td>
                        <td>2nd prize </td>
                        <td>2023</td>
                      </tr>
                      <tr>
                        <td>13</td>
                        <td>Bharath Kumar ,Jayanth shiva Madhav , Rahul </td>
                        <td>E-NNOVATE</td>
                        <td>Ikshana - Money Reader </td>
                        <td>Gold Category Award </td>
                        <td>2023</td>
                      </tr>
                      <tr>
                        <td>14</td>
                        <td>Abhinav.N , Yashwanth.L </td>
                        <td>E-NNOVATE</td>
                        <td>Hand Gesture Media Control</td>
                        <td>Silver Category Award </td>
                        <td>2023</td>
                      </tr>
                      <tr>
                        <td>15</td>
                        <td>Venkatesh M, Yashwanth.L</td>
                        <td>E-NNOVATE</td>
                        <td>Kisan Mitra </td>
                        <td>Silver Category Award </td>
                        <td>2023</td>
                      </tr>
                      <tr>
                        <td>16</td>
                        <td>
                          Venkata Sai Kiran, Abhinav, Tarun Aditya, Saathvika
                          Revalla
                        </td>
                        <td>E-NNOVATE</td>
                        <td>Air Purifying and Health monitoring</td>
                        <td>Bronze Category Award </td>
                        <td>2023</td>
                      </tr>
                      <tr>
                        <td>17</td>
                        <td>Sai Venkata Reddy</td>
                        <td>E-NNOVATE</td>
                        <td>Agrotech</td>
                        <td>Silver Category Award </td>
                        <td>2023</td>
                      </tr>
                    </tbody>
                  </table>

                  <table className="achievement-table" border="1">
                    <tbody>
                      <tr>
                        <th colSpan="6" className="year-header">
                          2022
                        </th>
                      </tr>
                      <tr>
                        <th>S.No</th>
                        <th>Club Member</th>
                        <th>Event Name</th>
                        <th>Title of Project/Product</th>
                        <th>Achievement</th>
                        <th>Year</th>
                      </tr>
                      <tr>
                        <td>1</td>
                        <td>
                          Varshitha, Siddhartha, Pranitha, Rahul of team (TEAM
                          TECHNOTUNERS)
                        </td>
                        <td>Smart India Hackathon 2022 </td>
                        <td></td>
                        <td>Nominated </td>
                        <td>2022</td>
                      </tr>
                      <tr>
                        <td>2</td>
                        <td>Wasim Akram, Sri Gouri (TEAM DRONACHARYA)</td>
                        <td>Smart India Hackathon 2022 </td>
                        <td></td>
                        <td>Nominated</td>
                        <td>2023</td>
                      </tr>
                      <tr>
                        <td>3</td>
                        <td>
                          Sai Kiran, Abhinav, Saathvika, Tarun Aditya (TEAM
                          TECHNOCRATS)
                        </td>
                        <td>Smart India Hackathon 2022 </td>
                        <td></td>
                        <td>Nominated</td>
                        <td>2023</td>
                      </tr>
                      <tr>
                        <td>4</td>
                        <td>Tharuni Rajesh, Sri Gouri (TEAM DHARANA) </td>
                        <td>Smart India Hackathon 2022 </td>
                        <td></td>
                        <td>Nominated</td>
                        <td>2023</td>
                      </tr>
                      <tr>
                        <td>5</td>
                        <td>Sai Suraj Joel (TEAM SHUDDH APAS)</td>
                        <td>Smart India Hackathon 2022 </td>
                        <td></td>
                        <td>Nominated</td>
                        <td>2022</td>
                      </tr>
                      <tr>
                        <td>6</td>
                        <td>
                          Santhosh, Bharath Kumar, Maliha, Shreya, Sri lekha
                          (TEAM IKSHANA)
                        </td>
                        <td>Smart India Hackathon 2022 </td>
                        <td></td>
                        <td>Nominated</td>
                        <td>2022</td>
                      </tr>
                      <tr>
                        <td>7</td>
                        <td>Sai Venkat Reddy, Anuhya, Sai Ram (TEAM VEDHAM)</td>
                        <td>Smart India Hackathon 2022 </td>
                        <td></td>
                        <td>Nominated</td>
                        <td>2023</td>
                      </tr>
                      <tr>
                        <td>8</td>
                        <td>
                          Adithya, Uday prasad, Bharath Kumar (TEAM INEVITABLE)
                        </td>
                        <td>Smart India Hackathon 2022 </td>
                        <td></td>
                        <td>Nominated</td>
                        <td>2022</td>
                      </tr>
                      <tr>
                        <td>9</td>
                        <td>Jayanth, Vijay, Tharun (TEAM TECHVITA)</td>
                        <td>Smart India Hackathon 2022 </td>
                        <td></td>
                        <td>Nominated</td>
                        <td>2022</td>
                      </tr>
                      <tr>
                        <td>10</td>
                        <td>Shashank, Muneeb (TEAM STRAWHAT)</td>
                        <td>Smart India Hackathon 2022 </td>
                        <td></td>
                        <td>Nominated</td>
                        <td>2022</td>
                      </tr>
                      <tr>
                        <td>11</td>
                        <td>
                          Narayana, Kinshuk, Sai Teja (TEAM LAKSHYA SIDDHI)
                        </td>
                        <td>Smart India Hackathon 2022 </td>
                        <td></td>
                        <td>Nominated</td>
                        <td>2022</td>
                      </tr>
                      <tr>
                        <td>12</td>
                        <td>
                          Vineeth, Bhuvan, Vishnu, Rossly, Srinath (TEAM
                          Ksheera)
                        </td>
                        <td>Smart India Hackathon 2022 </td>
                        <td></td>
                        <td>Nominated</td>
                        <td>2022</td>
                      </tr>
                    </tbody>
                  </table>

                  <table className="achievement-table" border="1">
                    <tbody>
                      <tr>
                        <th colSpan="6" className="year-header">
                          2019
                        </th>
                      </tr>
                      <tr>
                        <th>S.No</th>
                        <th>Club Member</th>
                        <th>Event Name</th>
                        <th>Title of Project/Product</th>
                        <th>Achievement</th>
                        <th>Year</th>
                      </tr>
                      <tr>
                        <td>1</td>
                        <td>Jayanth Reddy &amp; team</td>
                        <td>AAKRUTHI'19, OU</td>
                        <td> Krithi</td>
                        <td> 1st prize</td>
                        <td> 2019</td>
                      </tr>
                      <tr>
                        <td>2</td>
                        <td> Prajeeth,Nobel,Shravanth,Ashutosh</td>
                        <td> J-HUB Hackathon, MLRIT</td>
                        <td> PAFFBOT</td>
                        <td>2nd prize</td>
                        <td>2019</td>
                      </tr>
                      <tr>
                        <td>3</td>
                        <td>Yashwanth Gurram</td>
                        <td>J-HUB Hackfest, ACE Engineering College</td>
                        <td>Perigo</td>
                        <td>3rd prize</td>
                        <td> 2019</td>
                      </tr>
                      <tr>
                        <td>4</td>
                        <td>Muhammad Tabish</td>
                        <td>ELAN &amp;nvision-2019, IITH</td>
                        <td>AEROMODELLING</td>
                        <td> 1st prize</td>
                        <td> 2019</td>
                      </tr>
                      <tr>
                        <td>5</td>
                        <td>K.Ashutosh, Nobel Chowdary</td>
                        <td>
                          Bangkok International Intellectual Property,Invention,
                          Innovation and Technology Exposition
                        </td>
                        <td>New Generation Bathroom</td>
                        <td> Silver Medal</td>
                        <td> 2019</td>
                      </tr>
                      <tr>
                        <td>6</td>
                        <td> S.V.Soumya,M.Shvejan Shashank</td>
                        <td>
                          Bangkok International Intellectual Property,Invention,
                          Innovation and Technology Exposition
                        </td>
                        <td>Klen-The Smart Tag</td>
                        <td>Silver Medal</td>
                        <td>2019</td>
                      </tr>
                      <tr>
                        <td>7</td>
                        <td>Bhanu Teja, Sai krishna</td>
                        <td>ACUMEN'19,VASAVI COLLEGE OF ENGINEERING</td>
                        <td>HEXAPOD</td>
                        <td>1st prize </td>
                        <td>2018</td>
                      </tr>
                      <tr>
                        <td>8</td>
                        <td>G. Sai Krishna, BhanuTeja and team</td>
                        <td>MSME-thon 2019</td>
                        <td>HEXAPOD FOR DEFENCE</td>
                        <td>2nd prize </td>
                        <td>2018</td>
                      </tr>
                      <tr>
                        <td>9</td>
                        <td>Dilip,jayanth,bharath and Rahul</td>
                        <td>Aakruthi 2k19, Osmania University</td>
                        <td>CERV(CASUALTY EVACUATION ROBOT VEHICLE)</td>
                        <td>1st prize</td>
                        <td>2018</td>
                      </tr>
                      <tr>
                        <td>10</td>
                        <td>DattaLohit and team</td>
                        <td>Ignium2k19, GNITS</td>
                        <td>ALL-TERRAIN ROBOT</td>
                        <td>1st prize</td>
                        <td>2018</td>
                      </tr>
                      <tr>
                        <td>11</td>
                        <td>
                          Aitha Sai Krishna, M.M. Sai Prakash, Eswar Chand
                        </td>
                        <td>Indo-Taiwan Summit 2019</td>
                        <td>ARM CRAWLER</td>
                        <td>qualified for final round</td>
                        <td>2018</td>
                      </tr>
                    </tbody>
                  </table>

                  <table className="achievement-table" border="1">
                    <tbody>
                      <tr>
                        <th colSpan="6" className="year-header">
                          2018
                        </th>
                      </tr>
                      <tr>
                        <th>S.No</th>
                        <th>Club Member</th>
                        <th>Event Name</th>
                        <th>Title of Project/Product</th>
                        <th>Achievement</th>
                        <th>Year</th>
                      </tr>
                      <tr>
                        <td> 1</td>
                        <td>D. Vamsi</td>
                        <td>ROBOVANZA</td>
                        <td>Ball Catcher</td>
                        <td>2nd prize</td>
                        <td>2018</td>
                      </tr>
                      <tr>
                        <td> 2</td>
                        <td>D. Vamsi</td>
                        <td>MICROCOS'18 </td>
                        <td>Wheeleg bot</td>
                        <td>consolation prize</td>
                        <td>2018</td>
                      </tr>
                      <tr>
                        <td>3</td>
                        <td>D. Vamsi</td>
                        <td>ROBOVANZA</td>
                        <td>Balance on line</td>
                        <td>1st prize</td>
                        <td>2018</td>
                      </tr>
                      <tr>
                        <td> 4</td>
                        <td>
                          Mohammad Abdul Sami Shahid and Rajula Naga Rahul Reddy
                        </td>
                        <td>TECHNOVANZA 2K18</td>
                        <td>Project on vision</td>
                        <td>2nd prize</td>
                        <td>2018</td>
                      </tr>
                      <tr>
                        <td>5</td>
                        <td>G V V S Naveen and B. Varun</td>
                        <td>Student Innovation Competition,SNIST</td>
                        <td>WALL CLIMBING ROBOT</td>
                        <td>2nd prize</td>
                        <td>2018</td>
                      </tr>
                      <tr>
                        <td>6</td>
                        <td>G V V S Naveen and B. Varun</td>
                        <td>NavadharaPraudyogika, MECHARENA 2K18</td>
                        <td>WALL CLIMBING ROBOT</td>
                        <td>1st prize</td>
                        <td>2018</td>
                      </tr>
                      <tr>
                        <td>7</td>
                        <td>Shivani Manda</td>
                        <td>ELECTRIKA 2K18</td>
                        <td>STEW WORD ROBOT</td>
                        <td>1st prize</td>
                        <td>2018</td>
                      </tr>
                      <tr>
                        <td>8</td>
                        <td>Shivani Manda</td>
                        <td>AANVIK-2K18</td>
                        <td>STEW WORD ROBOT</td>
                        <td>3rd prize</td>
                        <td>2018</td>
                      </tr>
                      <tr>
                        <td>9</td>
                        <td>Bhanu Teja , Suraj</td>
                        <td>MECHARENA 2K18, OU</td>
                        <td>Navodara Praudyoguka</td>
                        <td>2nd prize</td>
                        <td>2018</td>
                      </tr>
                      <tr>
                        <td>10</td>
                        <td>Raj kumar</td>
                        <td>ROBOVANZA 2018</td>
                        <td>Balance on line bot</td>
                        <td>1st prize</td>
                        <td>2018</td>
                      </tr>
                      <tr>
                        <td>11</td>
                        <td>Santosh,Akhilesh,Sai kumar</td>
                        <td>AMITY UNIVERSITY</td>
                        <td>ROBOWARS-120lbs Category</td>
                        <td>2nd prize </td>
                        <td>2018</td>
                      </tr>
                      <tr>
                        <td>12</td>
                        <td>Niyaz,Dilip</td>
                        <td>Project Expo, HITAM college</td>
                        <td> CERV(CASUALTY EVACUATION ROBOT VEHICLE)</td>
                        <td>1st prize</td>
                        <td>2018</td>
                      </tr>
                      <tr>
                        <td>13</td>
                        <td>C Gokul Krishna and team</td>
                        <td>YANTRA YOJANA 2K18, VBIT</td>
                        <td>Line follower bot</td>
                        <td>1st prize</td>
                        <td>2018</td>
                      </tr>
                    </tbody>
                  </table>

                  <table className="achievement-table" border="1">
                    <tbody>
                      <tr>
                        <th colSpan="6" className="year-header">
                          2017
                        </th>
                      </tr>
                      <tr>
                        <th>S.No</th>
                        <th>Club Member</th>
                        <th>Event Name</th>
                        <th>Title of Project/Product</th>
                        <th>Achievement</th>
                        <th>Year</th>
                      </tr>
                      <tr>
                        <td>1</td>
                        <td>C Gokul Krishna and team</td>
                        <td>ASHRAJAN, VIVA VVIT</td>
                        <td>Line follower bot</td>
                        <td>1st prize</td>
                        <td>2017</td>
                      </tr>
                      <tr>
                        <td>2</td>
                        <td>C Gokul Krishna and team</td>
                        <td>TECHNO CARNIVAL 2k17, CMRTC</td>
                        <td>Robo race</td>
                        <td>1st prize</td>
                        <td>2017</td>
                      </tr>
                      <tr>
                        <td>3</td>
                        <td>A Sri Gautham</td>
                        <td>ASHRAJAN, VIVA VVIT</td>
                        <td>All Terrain bot</td>
                        <td>1st prize</td>
                        <td>2017</td>
                      </tr>
                      <tr>
                        <td>4</td>
                        <td>Yashwanth and Anirudh</td>
                        <td>International innovation fare</td>
                        <td>Smart bot</td>
                        <td>2nd prize</td>
                        <td>2017</td>
                      </tr>
                      <tr>
                        <td>5</td>
                        <td>D. Vamsi</td>
                        <td>ASHRAJAN, VIVA VVIT</td>
                        <td>All Terrain bot</td>
                        <td>1st prize</td>
                        <td>2017</td>
                      </tr>
                    </tbody>
                  </table>

                  <table className="achievement-table" border="1">
                    <tbody>
                      <tr>
                        <th colSpan="6" className="year-header">
                          2016
                        </th>
                      </tr>
                      <tr>
                        <th>S.No</th>
                        <th>Club Member</th>
                        <th>Event Name</th>
                        <th>Title of Project/Product</th>
                        <th>Achievement</th>
                        <th>Year</th>
                      </tr>
                      <tr>
                        <td>1</td>
                        <td>
                          Santhosh, Pavan, Chanakya gone, Pradeep and Mahesh
                        </td>
                        <td>
                          Texas Instruments Indian InnnovationDesign Challenge
                        </td>
                        <td>Visual Speech and Pot Hole Detection</td>
                        <td>Quarterfinalists</td>
                        <td>2016</td>
                      </tr>
                      <tr>
                        <td>2</td>
                        <td>Chanakya and Akshay Sreenivasan</td>
                        <td>ATMEL EMBEDDED DESIGN CONTEST</td>
                        <td>AUTOMATIC VOICE AIDED CHESS</td>
                        <td>Semifinalists</td>
                        <td>2016</td>
                      </tr>
                      <tr>
                        <td>3</td>
                        <td>R Satish, Mannava Kavya and P.V.S.S. Karthik</td>
                        <td>DRDO</td>
                        <td>DRUSE</td>
                        <td>qualified for 2nd level</td>
                        <td>2016</td>
                      </tr>
                      <tr>
                        <td>4</td>
                        <td>G V V S Naveen and B Varun</td>
                        <td>STUDENT INNOVATION COMPETETION</td>
                        <td></td>
                        <td>2nd prize</td>
                        <td>2016</td>
                      </tr>
                      <tr>
                        <td>5</td>
                        <td>CH Yashwanth</td>
                        <td>ATMOS, BITS PILANI</td>
                        <td>Proddigal Design</td>
                        <td>3rd prize</td>
                        <td>2016</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Achievement;
